exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\ninput[ type= \"number\" ] {\n  -moz-appearance: textfield;\n}\n.cell:empty::before{\n  content: '-';\n  color: gray;\n}\n.el-tooltip__popper{\n  max-width:30%\n}\n", ""]);

// exports
